module.exports = __webpack_public_path__ + "static/media/figure-3-humanoid-inc.155766a4.webp";